import EE from './events'
import Storage from './storage'
import Utils from './utils'
import Rangy from './rangy'
import { ElMessageBox } from 'element-plus'
import type { ElMessageBoxOptions, MessageBoxData, Action } from 'element-plus'
import i18n from '@/i18n'
export { default as MessageManager } from './messageManager'

interface MyAlert {
  (
    msg: ElMessageBoxOptions['message'],
    options?: {
      confirm?: () => void
      cancel?: () => void
      title?: string
    } & ElMessageBoxOptions
  ): Promise<MessageBoxData>
}

class Encapsulation {
  ee: EE
  storage: Storage
  utils: Utils
  rangy: Rangy

  constructor() {
    this.ee = new EE()
    this.storage = new Storage()
    this.utils = new Utils()
    this.rangy = new Rangy()
  }

  $myAlert: MyAlert = (
    msg,
    { confirm = () => {}, cancel = () => {}, ...options } = {}
  ) => {
    const { title } = options
    options = Object.assign(
      {
        dangerouslyUseHTMLString: true,
        cancelButtonText: i18n.global.t('cancel'),
        confirmButtonText: i18n.global.t('ok'),
        callback: async (action: Action) => {
          if (action === 'confirm') {
            // 点击了确定
            confirm()
          } else if (action === 'cancel') {
            // 点击了取消
            cancel()
          }
        },
        center: true,
        showClose: false,
        showCancelButton: true,
        closeOnClickModal: true,
        cancelButtonClass: 'message-box-cancel',
        confirmButtonClass: 'message-box-ok'
      },
      {
        ...options
      }
    )
    if (title === undefined) {
      options.customClass =
        (options.customClass || '') + 'hide-message-box__header'
    }
    return ElMessageBox.alert(msg, options)
  }
}
const ecp = new Encapsulation()

export { ecp, type Encapsulation }
